import { ChangeEvent, useCallback } from 'react';
import { useControlledState } from '../_core/hooks/use-controlled-state';

export const useControl = <T extends boolean | 'indeterminate'>(
  controlledChecked: T | undefined,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void,
  onCheckedChange?: (checked: T) => void
) => {
  const [checked, setChecked, isControlled] = useControlledState<T>(
    controlledChecked,
    false as T
  );

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setChecked(e.target.checked as T);
      onChange?.(e);
      onCheckedChange?.(e.target.checked as T);
    },
    [setChecked, onChange, onCheckedChange]
  );

  return { checked, handleChange, isControlled } as const;
};
